import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClienteService } from 'app/services/cliente.service';
import { SelectClientesComponent } from '../../clientes/select-clientes/select-clientes.component'
import { OrderService } from 'app/services/orders.service';
import { DialogDetailComponent } from '../../ordenes/dialog-detail/dialog-detail.component';
import { ToastrService } from 'ngx-toastr';
import { DialogCreateUpdateInteractionComponent } from '../../clientes/detail-client/dialog-create-update-interaction/dialog-create-update-interaction.component';
@Component({
  selector: 'app-dialog-create-or-update-casos',
  templateUrl: './dialog-create-or-update-casos.component.html',
  styleUrls: ['./dialog-create-or-update-casos.component.scss']
})
export class DialogCreateOrUpdateCasosComponent implements OnInit {

  casosForm: UntypedFormGroup;
  flexibleAttributesForm: UntypedFormGroup;
  notasForm: UntypedFormGroup;
  t1List: any[];
  t2List: any[];
  flexibleAttributes: any[];
  flexibleAttributesFiltered: any[]=[];
  flexibleAttributesValue: any[]=[];
  flexibleAttributesToCreate: any[] = [];
  flexibleAttributesValidate: false;
  t2ListFiltered: any[];
  vt2Selected: any;
  status: any[];
  customerList: any[];

  uuidCmEmployee =localStorage.getItem('uuidEmployee');
  /***********/
  // folioCtrl = new FormControl();
  /***********/
  flagShowCustomer = true;
  interaction: any={};
  ////////////////////////////////
  flagShowCustomerName = false;
  customerFancyName = '';
  customerRut = '';
  //
  answerList : any = [];
  answerUse : any = [];
  answerTXT : string = ''
  ///////////////////////////////
  matTabOrderSelected : number =0
  customerRelatedContact : any = []
  uuidCrmCustomer : string = ''
  rutCrmCustomer : string = ''
  flagValid :boolean = false
  ////////////////////////////////
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _dialogRef: MatDialogRef<DialogCreateOrUpdateCasosComponent>,
    private _fb: FormBuilder,
    private _clienteService: ClienteService,
    private _dialog: MatDialog,
    private _orderService : OrderService,
     private _toastr: ToastrService,

  ) {
    this.casosForm = this._fb.group({
      t1: [null,[Validators.required]],
      t2: [{value: null, disabled: true}],
      status: [0, [Validators.required]],
      txt: ['', [Validators.required, Validators.maxLength(1500)]],
      customer: ['0', [Validators.required]],
      uuidEomOrder    : ['0'],
      frienlyEomOrder : ['0'],
      uuidPsServices  :['0'],
      uuidCrmCustomerContact :[null, [Validators.required]] ,
      contactoReceptorMail : [null, [Validators.required]]
    });


    this.flexibleAttributesForm = this._fb.group({
      // FolioDoc: [''],
      // folio: [''],
      // refactura: [''],
      // montoReclamado: [''],
      // glosa: [''],
      // fecha: [''],
      // fechaHora: ['']
    });

  }
//######################################################
//######################################################
showSupplier(){
  const dialogRef = this._dialog.open(SelectClientesComponent, {
      
    height: '100%',
    width: '100%',
    data: {
       flagCustomer     : false
      ,flagSupplier     : false
      ,flagEmployee     : false
      ,flagAssociate    : false
      ,flagDistributor  : false
      ,flagDTE          : false
      ,flagALL          : true

    }
});
dialogRef.afterClosed().subscribe(async (result) => {

    this.casosForm.get('customer').setValue(result.UUID_CRM_CUSTOMER);
    this.uuidCrmCustomer   = result.UUID_CRM_CUSTOMER
    this.flagShowCustomerName = true;
    this.customerFancyName    = result.CUSTOMER_FANCY_NAME;
    this.customerRut          = result.RUT;
    this.getCustomerRelated(result.RUT,null)
    this.flagValid = true
});
}
//######################################################
//######################################################
async getCustomerRelated(rut: string,uuid: any): Promise<any>{
  var tmp
  tmp = await this._clienteService.customerRelated(rut,uuid);
  console.log(tmp)
    //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
    this.customerRelatedContact =tmp.contact
    //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$     
}
//######################################################
//######################################################
setContactoReceptorMail(e){
  var tmp = this.customerRelatedContact.filter(i => i.UUID_CRM_CUSTOMER_CONTACT == e)[0]
  console.log(e)
  console.log(tmp)
  this.casosForm.get('uuidCrmCustomerContact').setValue(e)
  this.casosForm.get('contactoReceptorMail').setValue(tmp.MAIL)
}
//######################################################
//######################################################
createContact(){

  const dialogRef = this._dialog.open(DialogCreateUpdateInteractionComponent, {
      
    height: '100%',
    autoFocus: false,
 
    width: '800px',
    data: {
        customer: null,
        type: 'create',
        tab:"contact",
        uuidCustomer : this.uuidCrmCustomer, 
        rut          : null,
        contact      : this.customerRelatedContact

    }
});

dialogRef.afterClosed().subscribe(async (result) => {
    
      await this.getCustomerRelated(null,this.uuidCrmCustomer)
});

}
//######################################################
//######################################################
  async ngOnInit(): Promise<void>{
    await this.casosForm.reset();
    ///////////////////
    //////////////////
    await this.getTypeInteractions();
    await this.getCustomers();
    if(this.data.type === 'update'){
      await this.getInteractionByUUID();
      this.casosForm.get('t2').enable();
    }
    //////////////////////
    if(this.data.uuidCrmCustomer ){
      console.log(this.data.uuidCrmCustomer)
      this.casosForm.get('customer').setValue(this.data.uuidCrmCustomer);
     
       await this.getCustomerRelated(null,this.data.uuidCrmCustomer)
      this.uuidCrmCustomer   = this.data.uuidCrmCustomer
      this.flagShowCustomer = false;
      this.flagValid = true
    }
    //////////////////////

    //////////////////////

  }
//######################################################
async makeFlexibleForm(form,master): Promise<void>{
  const $this = this;
  var flex : any = [];
    return await new Promise (async function(resolve, reject) {
      try {
        //##################################
         for(let i =0; i< master.length; i++){
            flex.push(
                        { 
                             idCmInteractionFlexibleAttributes  : master[i].ID_CM_INTERACTION_FLEXIBLE_ATTRIBUTES
                            ,valueFlexibleAttributes            : form.value[master[i].NAME_PARAM_FORM]
                        }
                    );
         }
         resolve(flex)
        //##################################
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }
//######################################################
  async create(): Promise<void>{
    let tmp =  (JSON.parse(localStorage.getItem('ssoData'))) 
    //###################################
    let arrFlex = await this.makeFlexibleForm(this.flexibleAttributesForm,this.flexibleAttributesFiltered)
    //###################################    
    const data = {
       uuidCrmCustomer              : this.uuidCrmCustomer//this.casosForm.value.customer
      ,uuidCmEmployee               : this.uuidCmEmployee
      ,idCmInteractionT2            : this.vt2Selected.ID_CM_INTERACTION_T2
      ,idCmInteractionStatus        : this.casosForm.value.status
      ,idParentCustomerInteraction  : 0
      ,flexibleAttributes           : arrFlex
      ,jCustomerInteraction         : {
        'txt': this.casosForm.value.txt,
        'date': new Date().toISOString(),
        'by': tmp.user.firstName + ' ' + tmp.user.lastName
      }
      ,uuidEomOrder           : this.casosForm.value.uuidEomOrder           || '0'
      ,frienlyEomOrder        : this.casosForm.value.frienlyEomOrder        || '0'
      ,uuidPsServices         : this.casosForm.value.uuidPsServices         || '0'
      ,uuidCrmCustomerContact : this.casosForm.value.uuidCrmCustomerContact || '0'
    };
    const resp = await this._clienteService.createInteraction(data);
    if(resp){
      this._dialogRef.close(true);
    }
  }
//######################################################
  async update(): Promise<void>{
    const user = ((JSON.parse(localStorage.getItem('emisorData'))).usrData[0]).USER;
    const data = {
       uuidCrmCustomer              : this.data.element.UUID_CRM_CUSTOMER
      ,uuidCrmCustomerInteraction   : this.interaction.UUID_CRM_CUSTOMER_INTERACTION
      ,idCmInteractionStatus        : this.casosForm.value.status
      ,jCustomerInteraction         : {
        'txt': this.casosForm.value.txt,
        'date': new Date().toISOString(),
        'by': user
      }
      ,uuidCrmCustomerContact : this.casosForm.value.uuidCrmCustomerContact || '0'
    } 
    const resp = await this._clienteService.updateInteraction(data);
    if(resp.status){
      this._dialogRef.close(true);
    };
  };
//######################################################
  asingValidators(): void{
    if(this.vt2Selected.FLAG_FLEXIBLE_ATTRIBUTES === 'Y'){
      this.flexibleAttributesFiltered.forEach((fa) => {
        if(fa.FLAG_MANDATORY_PARAM === 'Y'){
          this.flexibleAttributesForm.get(fa.NAME_PARAM_FORM).setValidators([Validators.required]);
        }
      });
    }
  }
//######################################################
  addToFormControl(): void{
    this.flexibleAttributesForm = this._fb.group({});
    this.flexibleAttributesFiltered.forEach((fa) => {
      this.flexibleAttributesForm.addControl(fa.NAME_PARAM_FORM, new FormControl(''));
    });
  }
//######################################################
  t1Selected(): void{
    this.casosForm.get('t2').enable();
    this.t2ListFiltered = this.t2List.filter(t2 => t2.ID_CM_INTERACTION_T1 === this.casosForm.value.t1);
    // this.t2List = this.t2List.map(t2 => { });
  }
//######################################################
  t2Selected(t2: any): void{
    this.vt2Selected = t2;
    // this.flexibleAttributesFiltered = [];
    if(t2.FLAG_FLEXIBLE_ATTRIBUTES === 'Y'){
      this.flexibleAttributesFiltered = this.flexibleAttributes.filter(fa => fa.ID_CM_INTERACTION_T2 === t2.ID_CM_INTERACTION_T2);
      this.flexibleAttributesFiltered.forEach((fa) => {
        fa.LIST_VALUES_PARAM = JSON.parse(fa.LIST_VALUES_PARAM);
      });
      this.addToFormControl();
    }

    this.asingValidators();

    this.getAnswer(this.vt2Selected)

  }
//######################################################
  async getInteractionByUUID(): Promise<void>{
    const { interaction, flexibleAttributes } = await this._clienteService.getInteractionByUUID(this.data.element.UUID_CRM_CUSTOMER, this.data.element.UUID_CRM_CUSTOMER_INTERACTION);
    await interaction.forEach((element) => {
      element.J_CUSTOMER_INTERACTION = JSON.parse(element.J_CUSTOMER_INTERACTION);
    });


    this.interaction = interaction[0];
    this.flexibleAttributesValue = flexibleAttributes;

    this.casosForm.get('t1').setValue(interaction[0].T1);
    this.casosForm.get('t2').setValue(interaction[0].T2);
    this.casosForm.get('t2').setValue(interaction[0].T2);
    this.casosForm.get('customer').setValue(this.data.element.UUID_CRM_CUSTOMER);

    let estado = this.status.filter(item => item.ID_CM_INTERACTION_STATUS == interaction[0].ID_CM_INTERACTION_STATUS)[0]
    if(estado.FLAG_END == 'Y'){
      this.casosForm.get('status').setValue(interaction[0].ID_CM_INTERACTION_STATUS);
      this.casosForm.get('status').disable();
    }else{
      this.casosForm.get('status').setValue(interaction[0].ID_CM_INTERACTION_STATUS);
    }

    this.casosForm.get('status').setValue(interaction[0].ID_CM_INTERACTION_STATUS);
    //////////////////
    console.log(interaction[0])
    this.customerRut = interaction[0].RUT
    await  this.getCustomerRelated(null,this.data.element.UUID_CRM_CUSTOMER )
    this.setContactoReceptorMail(interaction[0].UUID_CRM_CUSTOMER_CONTACT)


     this.uuidCrmCustomer   = this.data.element.UUID_CRM_CUSTOMER
     this.flagValid = true


  }
//######################################################

  async getTypeInteractions(): Promise<void>{
    const { t1, t2, status, type,rule,answer, flexibleAttributes } = await this._clienteService.getTypeInteractions();
    this.t1List = t1.filter(i => i.FLAG_PS_SERVICES == 'N');
    this.t2List = t2;
    this.status = status;
    this.flexibleAttributes = flexibleAttributes;
    let estado = this.status.filter(item => item.FLAG_START == 'Y')[0]
    if(estado.FLAG_START == 'Y') this.casosForm.get('status').setValue(estado.ID_CM_INTERACTION_STATUS);
    this.answerList = answer
    
  }
//######################################################
  async getCustomers(): Promise<void>{
    let tmp = await this._clienteService.getClientes();
   //console.log(data)
   this.customerList = tmp.activo;
  }
//######################################################
closeBtn(): void{
  this._dialogRef.close();
}
//######################################################
getAnswer(e){
var uuidT2 : string 
 if(this.data.type === 'update'){
    uuidT2 = this.interaction.UUID_CM_INTERACTION_T2
 }else{
    uuidT2 = this.vt2Selected.UUID_CM_INTERACTION_T2
 }
//==
console.log(uuidT2)
console.log(e)
console.log(this.answerList)
this.answerUse = this.answerList.filter(i => (i.UUID_CM_INTERACTION_T2 == uuidT2 && ( i.ID_CM_INTERACTION_STATUS == e || i.ID_CM_INTERACTION_STATUS == 0) ))
console.log(this.answerUse)
//==

//this.answerUse = 
}
//######################################################
setAnswer(e){
this.casosForm.get('txt').setValue( e.INTERACTION_ANSWER);
}
//######################################################
orderDetail(uuidEomOrder: string): void {
  this._orderService.getOrdersDetail(uuidEomOrder).then((res) => {
    // console.log(res);

    const dialogRef =  this._dialog.open(DialogDetailComponent, {
      //width: '1200px',
      //height: '600px',
      width: '100%',
      height: '100%',
      data: res.dataSet
    });
    dialogRef.afterClosed().subscribe(async result => {
      
       if(!!result){
        //this.ngAfterViewInit() 
       }
     });    
  })
}
//########################################################
}
